import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface JasperBookState {
    data: any[];
}

const initialState: JasperBookState = {
    data: [],
};

const jasperBooksSlice = createSlice({
    name: 'jasper-books',
    initialState,
    reducers: {
        setJasperBooksData: (state, action: PayloadAction<any[]>) => {
            state.data = action.payload;
        },
    },
});

export const { setJasperBooksData } = jasperBooksSlice.actions;
export default jasperBooksSlice.reducer;
